<template>
  <div id="claim-report-add">
    <vs-row style="flex-wrap: wrap-reverse">
      <vs-col vs-lg="9" vs-sm="12">
        <common-text-large text="新規事故報告" class="mb-4" />
        <div class="vx-card p-8 h-full">
          <div class="content-between">
            <common-text-medium class="mb-4" text="送信完了" />
            <p>事故報告を送信しました。</p>
            <p>保険会社側で確認しますので、少々お待ち下さい。</p>
          </div>
          <div class="w-full flex justify-center mt-4">
            <common-button
              title="事故一覧に戻る"
              :click="click"
              icon="keyboard_arrow_left"
            ></common-button>
          </div>
        </div>
      </vs-col>
      <vs-col class="right-widget-area" vs-lg="3" vs-sm="12"> </vs-col>
    </vs-row>
  </div>
</template>

<script>
import CommonButton from '../components/molecules/CommonButton.vue';
import CommonTextLarge from '../components/atoms/CommonTextLarge.vue';
import CommonTextMedium from '../components/atoms/CommonTextMedium.vue';

import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("hullInsuranceAddReport");

export default {
  name: "T.ClaimReportAddComplete",

  components: {
    CommonTextLarge,
    CommonTextMedium,
    CommonButton
  },

  methods: {
    ...mapMutations(["SET_INPUT_VALUE", "SET_PICTURES", "SET_FREE_FILES"]),
    click() {
      this.$router.push({
        name: "hull-insurance-claim-report-list",
      });
    },
  },
  mounted() {
    this.SET_INPUT_VALUE({});
    this.SET_PICTURES([]);
    this.SET_FREE_FILES([]);
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";
@import "@/assets/scss/aisea/hull-insurance.scss";
.right-widget-area {
  padding-left: 20px;
  max-width: 240px;
}

.add-label {
  font-size: 14px;
  font-family: $aisea-font-family;
  font-weight: 600;
  color: $common-text-dark-gray;
}

.delete-button {
  padding: 9px;
  color: $icon-gray;
  border-radius: 6px;
  border: 1px solid $border-color1;
}

.free-annotation-text {
  font-size: 14px;
  font-family: $aisea-font-family;
  color: $common-text-dark-gray;
}
</style>